export default "__VITE_ASSET__DBEA5vcj__"